"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerifyTradePwdRequest = void 0;
var VerifyTradePwdRequest = /** @class */ (function () {
    function VerifyTradePwdRequest() {
    }
    return VerifyTradePwdRequest;
}());
exports.VerifyTradePwdRequest = VerifyTradePwdRequest;
;
//# sourceMappingURL=verifyTradePwd.request.js.map